import * as React from 'react';
import { toPath } from '../../common/helpers/toPath';
import { IDictionary, IPage } from '../../common/interfaces/main';
import { PrivateRoute } from '../src/components/route/private/PrivateRoute';
import { EUserTypeName } from '../../common/interfaces/user';
import InternalMain from '../src/routes/internal/InternalMain';
import PortalMain from '../src/routes/portal/PortalMain';
import AdminMain from '../src/routes/admin/AdminMain';

class Page {
    constructor(public name: EUserTypeName, public component: any) {
        this.path = toPath(this.name);
        this.route = (
            <PrivateRoute
                key={this.name}
                authorizedUserTypes={[this.name, EUserTypeName.Admin]}
                path={`/${this.path}`}
                component={this.component}
            />
        );
    }

    public path: string = '';
    public route = null;
}

export const pages: IPage[] = [
    new Page(EUserTypeName.Admin, AdminMain),
    new Page(EUserTypeName.Internal, InternalMain),
    new Page(EUserTypeName.Portal, PortalMain)
];

export const pagesDictionary: IDictionary<IPage> = pages.reduce((routing, currentPage) => {
    routing[toPath(currentPage.name)] = currentPage;
    return routing;
}, {});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/data/content.tsx